import { Base64 } from 'js-base64';

export function decodeBase64Text(value: string): string {
  try {
    return JSON.parse(Base64.decode(value));
  } catch (error) {
    return '';
  }
}
